import { stringify } from 'querystring';
import { BaseClient } from '@is24at/react-utils';

class LocalGeoClient extends BaseClient {
  fetchGeoHierarchy = async (regionId: any) =>
    this.fetch(`/local/geoHierarchy/${regionId}`);

  decodeGeoEntityFrom = async (path: any) =>
    this.fetch(`/local/geoEntity?${stringify({ path })}`);
}

export default LocalGeoClient;
